import { Pipe, PipeTransform } from '@angular/core';

import { PriceModificationType } from './../../../../app/modules/pricing/interfaces/pricing.interface';


@Pipe({
  name: 'pricingMatrix',
  standalone: true,
})
export class PricingMatrixPipe implements PipeTransform {
  transform(
    basePrice :number,
    tierAmount :number,
    modificationType :string,
    percentIncrease :number,
  ) :number {
    let adjusted = basePrice;
    if (modificationType === PriceModificationType.FIXED) {
      adjusted = basePrice - Number(tierAmount);
    } else {
      // PERCENT: treat tierAmount as a percent discount
      adjusted = basePrice - (Number(tierAmount) / 100) * basePrice;
    }
    // Now apply the price level percent increase/discount

    return Number((adjusted - (Number(percentIncrease) / 100) * adjusted).toFixed(2));
  }
} 
